// P A G E L O A D

// Init Functions on Document Ready
document.addEventListener("DOMContentLoaded", () => {
  init();
  //console.log("Document Ready");
});

// I N I T

// Init all functions
function init() {
  //console.log("Init all functions");

  videoButton();

  //selective function
  if (document.querySelector(".logo-swiper")) {
    logoSwiper();
  }
}

// F U N C T I O N S

// logo swiper
function logoSwiper() {
  //console.log("Logo Swiper script loaded");
  const swiper = new Swiper(".logo-swiper", {
    // Default parameters (mobile)
    direction: "horizontal",
    loop: true,
    slidesPerView: "3",
    spaceBetween: 20,
    autoplay: {
      delay: 5000,
      disableOnInteraction: true,
    },

    // Responsive breakpoints
    breakpoints: {
      768: {
        slidesPerView: 4,
        spaceBetween: 50,
      },
      992: {
        slidesPerView: 6,
      },
    },
  });
}

// custom video button
function videoButton() {
  //console.log("Video script loaded");

  // get elements
  let videos = document.querySelectorAll(".video"); // get all videos
  let buttons = document.querySelectorAll(".play-button"); // get all buttons

  // Assign a click event listener to each button
  videos.forEach((video, index) => {
    let button = buttons[index];

    // Check if the autoplay attribute is present
    if (!video.hasAttribute("autoplay")) {
      // Assign a click event listener to the corresponding button
      button.addEventListener("click", function () {
        video.play();
        video.controls = true;
        button.style.display = "none"; // Hide the button
      });
    } else {
      // If autoplay is present, hide the corresponding button
      button.style.display = "none";
    }
  });
}
